module.exports = __webpack_public_path__ + "vd/assets/audio//success.216734d.mp3";